import * as React from 'react'
import Avatar from '~/client/components/Avatar'

export default function AppIcon({ app, ...props }){
  return <Avatar {...{
    ...props,
    src: app.logo,
    alt: app.name,
  }}/>
}
